export enum NavBarActionType {
    SWITCH = 'switch',
}